import { createElement, ReactElement } from "react";
import { toast, ToastOptions } from "react-hot-toast";

import { ApiError } from "@config/apiClient";

export type ErrorResponse = {
  message?: string;
  detail?: string;
  __all__?: string[];
};

class ToastService {
  static showError(error: ApiError | string, userMessage?: ReactElement, options?: ToastOptions): void {
    if (userMessage) {
      this.showUserError(createElement("span", null, userMessage), { id: "error", ...options });
      return;
    }

    const errorMessage = this.getErrorMessage(error);
    if (Array.isArray(errorMessage)) {
      errorMessage.forEach((message) => {
        toast.error(message, { id: message, ...options });
      });
    } else {
      toast.error(errorMessage, { id: errorMessage, ...options });
    }
  }

  static showUserError(message: ReactElement, options?: ToastOptions): void {
    toast.error(() => message, { id: "error", ...options });
  }

  static showSuccess(message: string, options?: ToastOptions): void {
    toast.success(message, { id: message, ...options });
  }

  static dismiss(id?: string): void {
    toast.dismiss(id);
  }

  static getErrorMessage(error: ApiError | string): string | string[] {
    if (typeof error === "string") {
      return error;
    } else if (error.response && error.response.data) {
      const responseData = error.response.data as ErrorResponse;
      return responseData.message || responseData.detail || responseData.__all__ || "Server error";
    } else if (error.request) {
      return "Server is not available";
    } else {
      return error.message || "Something went wrong, please try again";
    }
  }
}

export default ToastService;
